module.exports = global["$"] = require("-!/home/xander/GitHub/FLAVIA/node_modules/expose-loader/index.js?jQuery!/home/xander/GitHub/FLAVIA/node_modules/source-map-loader/index.js!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 2
// module chunks = 0